/**
 * @file contains helper functions for the HexColorInput component
 */
import { GENERAL__COLOR_REGEX } from '../../../constants/forms';

/**
 * Escapes all non-hexadecimal characters including "#"
 *
 * @param value The value to escape
 *
 * @returns     The escaped value
 */
export const escapeCharacters = (value: string) =>
  value.replace(/([^0-9A-F]+)/gi, '').substring(0, 6);

/**
 * Formats a number to a hexadecimal string
 *
 * @param number The number to format
 *
 * @returns      The formatted hexadecimal string
 */
export const formatToHex = (number: number) => {
  const hex = number.toString(16);
  return hex.length < 2 ? '0' + hex : hex;
};

/**
 * Validates hexadecimal strings
 *
 * @param value The value to validate
 *
 * @returns     Whether the value is a valid hexadecimal string
 */
export const validateHex = (value: string): boolean => {
  return new RegExp(GENERAL__COLOR_REGEX).test(value);
};
